import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const getProducts = (params = {}) => api.get("/products", { params }).then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const getCategories = () => api.get("/products/categories").then((r) => r.data);
export const sendIntakeMessage = (session_id, message) =>
  api.post("/intake/chat", { session_id, message }).then((r) => r.data);
export const getOrder = (id) => api.get(`/orders/${id}`).then((r) => r.data);

// Auth
export const postSession = (session_id) => api.post("/auth/session", { session_id }).then((r) => r.data);
export const getMe = () => api.get("/auth/me").then((r) => r.data);
export const logout = () => api.post("/auth/logout").then((r) => r.data);
export const getMyOrders = () => api.get("/orders/me").then((r) => r.data);

// Checkout
export const createCheckout = (payload) => api.post("/checkout/session", payload).then((r) => r.data);
export const getCheckoutStatus = (session_id) => api.get(`/checkout/status/${session_id}`).then((r) => r.data);
